import * as React from 'react';
import { Button, ButtonPriority, ButtonSize } from '../../Button';
import { TextButton, TextButtonPriority } from '../../TextButton';
import { SECTION_NOTIFICATION_DATA_HOOKS } from '../dataHooks';
import { classes as parentClasses } from '../SectionNotification.deprecated.st.css';
import { SectionNotificationType, SectionNotificationButtonType, } from '../types';
import { st, classes } from './SectionNotificationButton.st.css';
import { SectionNotificationConsumer } from '../SectionNotificationContext';
export class SectionNotificationButton extends React.Component {
    constructor() {
        super(...arguments);
        this.textButtonDefaultProps = {
            priority: TextButtonPriority.primary,
        };
        this.buttonDefaultProps = {
            priority: ButtonPriority.basic,
            size: ButtonSize.tiny,
        };
    }
    render() {
        const { children, type, ...buttonProps } = this.props;
        const ButtonComponent = type === SectionNotificationButtonType.text ? TextButton : Button;
        const defaultButtonProps = type === SectionNotificationButtonType.text
            ? this.textButtonDefaultProps
            : this.buttonDefaultProps;
        return (React.createElement(SectionNotificationConsumer, null, ({ type: notificationType }) => (React.createElement("div", { className: st(classes.root, {
                type,
                wired: notificationType === SectionNotificationType.wired,
            }, parentClasses.button), "data-hook": SECTION_NOTIFICATION_DATA_HOOKS.button },
            React.createElement(ButtonComponent, { className: st(classes.button, {
                    priority: buttonProps.priority || defaultButtonProps.priority,
                }), ...defaultButtonProps, ...buttonProps }, children)))));
    }
}
SectionNotificationButton.displayName = 'SectionNotification.Button';
SectionNotificationButton.defaultProps = {
    type: SectionNotificationButtonType.default,
};
//# sourceMappingURL=SectionNotificationButton.js.map